module.exports = __webpack_public_path__ + "img/right-red-arrow.ba684847.svg";